import {
  PRIZE_MODAL_PRODUCTS_ABORT_KEY,
  PRIZE_MODAL_PRODUCTS_COUNT,
} from '../constants'
import {
  buildSlotsFromProducts,
  clearRemainingSkeletonSlots,
  createSkeletonSlots,
  hasPrizeProductsLink,
  mapProductsForCards,
  mergeProductsIntoSkeletonSlots,
  shouldShowPrizeModalProducts,
} from '../utils/prize-modal-products'

// TODO: вынести на общий уровень
const isAbortedError = (error) => error?.aborted === true

export class MainService {
  constructor(gaApp) {
    this.gaApp = gaApp
  }

  abortPrizeModalProductsLoad() {
    this.gaApp.api.requestAbort.abortRequest(PRIZE_MODAL_PRODUCTS_ABORT_KEY)
  }

  /**
   * Загрузка подборки товаров для модалки приза.
   * @returns {Array|null} слоты для отображения или null, если запрос отменён
   */
  async loadPrizeModalProducts({
    products = [],
    productsLink = '',
    shouldEnrichProducts = false,
  } = {}) {
    if (
      !shouldShowPrizeModalProducts({
        products,
        productsLink,
        shouldEnrichProducts,
      })
    ) {
      return []
    }

    const hasSkuList = Boolean(products?.length)
    const hasProductsLink = hasPrizeProductsLink(productsLink)
    const requestOptions = { abortKey: PRIZE_MODAL_PRODUCTS_ABORT_KEY }

    try {
      let mappedSkuProducts = []
      let displaySlots = createSkeletonSlots()

      if (hasSkuList) {
        const skuProducts =
          await this.gaApp.services.product.api.fetchProductsBySku(
            products,
            requestOptions,
          )

        mappedSkuProducts = mapProductsForCards(skuProducts)

        displaySlots = buildSlotsFromProducts(
          mappedSkuProducts,
          PRIZE_MODAL_PRODUCTS_COUNT,
        )
      }

      // fetchProductsBySku уже отфильтровал out-of-stock — length === числу карточек в наличии
      const inStockCount = mappedSkuProducts.length

      if (inStockCount >= PRIZE_MODAL_PRODUCTS_COUNT) {
        return displaySlots
      }

      if (!hasProductsLink || !shouldEnrichProducts) {
        return clearRemainingSkeletonSlots(displaySlots)
      }

      const excludeItemIds = mappedSkuProducts.map((product) => product.itemId)
      const slotsToFill = PRIZE_MODAL_PRODUCTS_COUNT - inStockCount

      try {
        const supplementProducts =
          await this.gaApp.services.product.api.fetchSupplementProductsByLink(
            productsLink,
            {
              excludeItemIds,
              limit: slotsToFill,
            },
            requestOptions,
          )

        const mappedSupplement = mapProductsForCards(supplementProducts)

        displaySlots = mergeProductsIntoSkeletonSlots(
          displaySlots,
          mappedSupplement,
        )
      } catch (error) {
        if (isAbortedError(error)) {
          return null
        }
      }

      return clearRemainingSkeletonSlots(displaySlots)
    } catch (error) {
      if (isAbortedError(error)) {
        return null
      }

      return clearRemainingSkeletonSlots(createSkeletonSlots())
    }
  }
}
